import 'css-chunksrc/client/common/tag/styles.scss';export default {
  "tag": "_tag_lw06g_1",
  "icon": "_icon_lw06g_26",
  "removeTagIconContainer": "_removeTagIconContainer_lw06g_38",
  "name": "_name_lw06g_44"
};